import { NavLink, Link } from "react-router-dom";

import styles from "./styles.module.css"
import { signOut } from "firebase/auth"
import { auth } from "../../../services/firebase-config";

import { MdMenu, MdOutlineEditNote } from "react-icons/md"
import { IoBookSharp, IoPeople } from "react-icons/io5"
import {BiCategory} from "react-icons/bi"
import { BsQuestionSquareFill } from "react-icons/bs"


import { useNavigate } from "react-router-dom"
import { useState } from "react";


export default function Header() {

    const [showMobileNav, setShowMobileNav] = useState(false);

    let navigate = useNavigate();

    function changeMobileNav() {
        if (showMobileNav) {
            setShowMobileNav(false);
        } else {
            setShowMobileNav(true);
        }
    }

    async function logout() {
        await signOut(auth);
        navigate('/login', { replace: true })

    }

    return (
        <>
            <div className={styles.header}>
                <Link className={styles.header__title} to='/'>
                    Painel IDE
                </Link>
                <nav className={styles.header__nav}>
                    <ul >
                        {/* <li>
                            <NavLink
                                to="books"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoBookSharp />
                                </div>

                                Lista de livros
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                to="E-books"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoBookSharp />
                                </div>
                                Lista de E-books
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="users"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoPeople />
                                </div>
                                Lista de Usuários
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="common_questions"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <BsQuestionSquareFill />
                                </div>
                                Perguntas Frequentes
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="categories"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <BiCategory/>
                                </div>
                                Categorias
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="appcontent"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <MdOutlineEditNote/>
                                </div>
                                Aplicativo IDE
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <button className={styles.logoutButton} onClick={() => { logout() }}>Sair</button>
            </div>

            <div className={styles.headerMobile}>
                <div className={styles.headerMobile__head}>
                    <Link className={styles.headerMobile__title} to='/'>
                        Painel IDE
                    </Link>
                    <button className={styles.headerMobile__title} onClick={() => { changeMobileNav() }}><MdMenu /></button>

                </div>

                <nav className={showMobileNav ? `${styles.headerMobile__nav} ${styles.active}` : styles.headerMobile__nav}>
                    <ul >
                        {/* <li>
                            <NavLink
                                to="books"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoBookSharp />
                                </div>

                                Lista de livros
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                to="E-books"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoBookSharp />
                                </div>
                                Lista de e-books
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="users"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <IoPeople />
                                </div>
                                Lista de Usuários
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="common_questions"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <BsQuestionSquareFill />
                                </div>
                                Perguntas frequentes
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="categories"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <BiCategory/>
                                </div>
                                Categorias
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="appcontent"
                                className={({ isActive }) =>
                                    isActive ? `${styles.navLink} ${styles.active}` : `${styles.navLink}`
                                }
                            >
                                <div className={styles.navLink__icon}>
                                    <MdOutlineEditNote/>
                                </div>
                                Aplicativo
                            </NavLink>
                        </li>
                    </ul>
                    <button className={styles.logoutButton} onClick={() => { logout() }}>Sair</button>
                </nav>
            </div>
        </>

    );
}